/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { Component } from 'react';
// material
import { Grid, SelectableList, Title, Group } from '@insticator/insticator-ui'; // iui-material
import Area from 'pages/dashboard/reports/detail/area/area';
// styles
import injectSheet from 'react-jss';
import styles from 'pages/dashboard/reports/detail/metrics/metrics_styles';



/* ========== ~~~~~~~~~~ REPORT METRICS ~~~~~~~~~~ ========== */
class ReportMetrics extends Component {
	constructor(props){
		super(props);
	}

	handleChangeMetrics = (value) => {
		this.props.setReportProperties({viewType: value,
						metrics: ["VIDEO_CPM", "VIDEO_IMPRESSION", "VIDEO_REVENUE", "DISPLAY_CPM", "DISPLAY_IMPRESSION", "DISPLAY_REVENUE"],
					  selectedReportDataValid: Object.assign({}, this.props.valid, {metrics: true})});
	}

	renderAggregateList = () => (
		<div className={'metrics-options'}>
			<Title size={`small`}>
				<h1>Aggregate (Display + Video)</h1>
			</Title>
			<SelectableList type='checkbox' selected={
				[(this.props.viewType === 'AGGREGATE' && this.props.metrics.includes('DISPLAY_IMPRESSION')) ? 'IMPRESSION' : null,
				(this.props.viewType === 'AGGREGATE' && this.props.metrics.includes('DISPLAY_REVENUE')) ? 'REVENUE' : null,
				(this.props.viewType === 'AGGREGATE' && this.props.metrics.includes('DISPLAY_CPM')) ? 'CPM' : null]
			} items={[{value: 'IMPRESSION', text: 'Impressions'},
				{value: 'REVENUE', text: 'Revenue'}, {value: 'CPM', text: 'CPM'}]}
				  handleChange={(value) => this.updateMetricsProps(value)}/>
		</div>
	);

	renderBreakdownList = () => (
		<Group direction={`horizontal`}>
			<div className={'metrics-options'}>
				<Title size={`small`}>
					<h1>Display Ads</h1>
				</Title>
				<SelectableList type='checkbox' selected={this.props.metrics} items={[{value: 'DISPLAY_IMPRESSION', text: 'Impressions'},
					{value: 'DISPLAY_REVENUE', text: 'Revenue'}, {value: 'DISPLAY_CPM', text: 'CPM'}]}
					  handleChange={(value) => this.updateMetricsProps(value)}/>
			</div>
			<div className={'metrics-options'}>
				<Title size={`small`}>
					<h1>Video Ads</h1>
				</Title>
				<SelectableList type='checkbox' selected={this.props.metrics} items={[{value: 'VIDEO_IMPRESSION', text: 'Impressions'},
					{value: 'VIDEO_REVENUE', text: 'Revenue'}, {value: 'VIDEO_CPM', text: 'CPM'}]}
					  handleChange={(value) => this.updateMetricsProps(value)}/>
			</div>
		</Group>
	);

	handleAggregateMetrics = (value) => {
		let metrics = [...this.props.metrics];
		switch(value) {
			case 'IMPRESSION':
				if(metrics.indexOf('VIDEO_IMPRESSION') === -1) {
					metrics.push('VIDEO_IMPRESSION');
					metrics.push('DISPLAY_IMPRESSION');
				} else {
					metrics.splice(metrics.indexOf('VIDEO_IMPRESSION'), 1);
					metrics.splice(metrics.indexOf('DISPLAY_IMPRESSION'), 1);
				}
				break;
			case 'REVENUE':
				if(metrics.indexOf('VIDEO_REVENUE') === -1) {
					metrics.push('VIDEO_REVENUE');
					metrics.push('DISPLAY_REVENUE');
				} else {
					metrics.splice(metrics.indexOf('VIDEO_REVENUE'), 1);
					metrics.splice(metrics.indexOf('DISPLAY_REVENUE'), 1);
				}
				break;
			case 'CPM':
				if(metrics.indexOf('VIDEO_CPM') === -1) {
					metrics.push('VIDEO_CPM');
					metrics.push('DISPLAY_CPM');
				} else {
					metrics.splice(metrics.indexOf('VIDEO_CPM'), 1);
					metrics.splice(metrics.indexOf('DISPLAY_CPM'), 1);
				}
				break;
			default:
				// console.log(value)
		}
		return metrics;
	}

	handleBreakdownMetrics = (value) => {
		let metrics = [...this.props.metrics];
		switch (value) {
			case 'VIDEO_IMPRESSION':
				if (metrics.indexOf('VIDEO_IMPRESSION') === -1) {
					metrics.push('VIDEO_IMPRESSION');
				} else {
					metrics.splice(metrics.indexOf('VIDEO_IMPRESSION'), 1)
				}
				break;
			case 'DISPLAY_IMPRESSION':
				if (metrics.indexOf('DISPLAY_IMPRESSION') === -1) {
					metrics.push('DISPLAY_IMPRESSION');
				} else {
					metrics.splice(metrics.indexOf('DISPLAY_IMPRESSION'), 1)
				}
				break;
			case 'VIDEO_REVENUE':
				if (metrics.indexOf('VIDEO_REVENUE') === -1) {
					metrics.push('VIDEO_REVENUE');
				} else {
					metrics.splice(metrics.indexOf('VIDEO_REVENUE'), 1)
				}
				break;
			case 'DISPLAY_REVENUE':
				if (metrics.indexOf('DISPLAY_REVENUE') === -1) {
					metrics.push('DISPLAY_REVENUE');
				} else {
					metrics.splice(metrics.indexOf('DISPLAY_REVENUE'), 1)
				}
				break;
			case 'VIDEO_CPM':
				if (metrics.indexOf('VIDEO_CPM') === -1) {
					metrics.push('VIDEO_CPM');
				} else {
					metrics.splice(metrics.indexOf('VIDEO_CPM'), 1)
				}
				break;
			case 'DISPLAY_CPM':
				if (metrics.indexOf('DISPLAY_CPM') === -1) {
					metrics.push('DISPLAY_CPM');
				} else {
					metrics.splice(metrics.indexOf('DISPLAY_CPM'), 1)
				}
				break;
			default:
				// console.log(value)
		}
		return metrics
	}

	getUpdatedMetrics = (value) => {
		if(this.props.viewType === 'AGGREGATE')
			return this.handleAggregateMetrics(value);
		if(this.props.viewType === 'BREAKDOWN')
			return this.handleBreakdownMetrics(value);
	}

	updateMetricsProps = (value) => {
		let metrics = this.getUpdatedMetrics(value);
		this.props.setReportProperties({metrics: metrics,
							selectedReportDataValid: Object.assign({}, this.props.valid, {metrics: metrics.length > 0})});
	}

    render() {
		return (
			<Area name={`metrics`}
				  klass={`${this.props.classes.metrics}`}
				  title={`Metrics`}
				  tooltip={<p>Metrics will constitute individual rows on your report.</p>}>
				<Grid>
					<SelectableList type='radio' selected={this.props.viewType}
						  items={[{value: 'AGGREGATE', text: 'Show display and video as aggregate'},
							  {value: 'BREAKDOWN', text: 'Break down display and video'}]}
						  handleChange={(value) => this.handleChangeMetrics(value)}/>
					{this.props.viewType === 'AGGREGATE' && this.renderAggregateList()}
					{this.props.viewType === 'BREAKDOWN' && this.renderBreakdownList()}
				</Grid>
				{this.props.valid.metrics === false ? <div className={'errormessage'}>A minimum of one metric is required.</div> : null}
			</Area>
		);
	}
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(ReportMetrics);
